import React, { Component } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import {
  Link,
  Redirect,
} from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/certificate.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import MdlSelectExamClassAndMultipleStudent from "../dialog/MdlSelectExamClassAndMultipleStudent";
import MdlReportCardSettings from "../dialog/MdlReportCardSettings";
import BackButton from "../ChildComponent/BackButton";

/** Printable samples for cover page (separate from main annual report card list) */
const DOCUMENT_TYPE_REPORT_CARD_COVER = "report_card_cover";

//Created By Cursor — parse session date strings for month list
function parseLooseDate(raw) {
  if (!raw) return null;
  const s = String(raw).trim();
  if (!s) return null;
  const d = new Date(s.includes("T") ? s : s.replace(/-/g, "/"));
  if (!Number.isNaN(d.getTime())) return d;
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return null;
}

//Created By Cursor — session months as YYYY-MM (e.g. 2026-10)
function buildSessionMonths(startRaw, endRaw) {
  const session = SessionManager.getCurrentSession()?.[0];
  const start =
    parseLooseDate(startRaw) || parseLooseDate(session?.start_date);
  const end = parseLooseDate(endRaw) || parseLooseDate(session?.end_date);
  if (!start || !end) {
    const now = new Date();
    return [`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`];
  }
  const months = [];
  const cursor = new Date(start.getFullYear(), start.getMonth(), 1);
  const last = new Date(end.getFullYear(), end.getMonth(), 1);
  if (cursor > last) {
    const now = new Date();
    return [`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`];
  }
  while (cursor <= last) {
    months.push(
      `${cursor.getFullYear()}-${String(cursor.getMonth() + 1).padStart(2, "0")}`
    );
    cursor.setMonth(cursor.getMonth() + 1);
  }
  return months.length
    ? months
    : [
        `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(
          2,
          "0"
        )}`,
      ];
}

const REPORT_PAGE_TYPES = [
  {
    value: "BACK_PAGE",
    label: "Back Page (Process Report)",
    title: "BACK PAGE (PROCESS REPORT)",
    icon: "fa-file-text-o",
    color: "#3b82f6",
  },
  {
    value: "COVER_PAGE",
    label: "Cover Page",
    title: "COVER PAGE",
    icon: "fa-file",
    color: "#10b981",
  },
];

export default class ExamStudentReportCard extends Component {
  constructor(props) {
    super(props);

    const token = localStorage.getItem("token");
    let loggedIn = true;
    if (token == null) {
      loggedIn = false;
    }

    this.state = {
      loggedIn: loggedIn,
      Loading: false,
      isOpenSelectStudent: false,
      isOpenSettings: false,
      showPreview: false,
      Total: 0,
      mSelectedStudent: [],
      SELECTED_STUDENT_ID: "",
      mSamples: [],
      mSettings: [],
      mCoverSettings: [],
      mColorOption: [],
      iFrameHeight: "2500px",
      SELECTED_SAMPLE_ID: "",
      SELECTED_SAMPLE_POSITION: 0,
      SELECTED_COLOR_OPTION_POSITION: 0,
      SELECTION_TYPE: "",
      FILE_URL: "",
      FILE_NAME: "",
      FILE_DIRECTORY: "",
      REPORT_CARD_ID: "",
      EXAM_ID: "",
      SESSION_ID: "",
      COLOR_OPTION_ID: "",
      REPORT_CARD_TYPE: "ANNUAL",
      MANUAL_ATTENDANCE: "",
      isOpenColorDropdown: false,
      // Cover page handling
      isCoverPageEnabled: false,
      COVER_SAMPLE_ID: "",
      COVER_SAMPLE_POSITION: 0,
      // Report page type (back / cover)
      reportPageType: "BACK_PAGE",
      // Whether both sides need cover page
      needCoverPageBothSide: false,
      // Local editable copy of report card settings
      mSettingsLocal: null,
      mCoverSettingsLocal: null,
      // Cover page templates from getPrintableSample (document_type report_card_cover)
      mCoverSamples: [],
      loadingCoverSamples: false,
      savingReportSettings: false,
      /** Incremented each time preview URL is rebuilt so the iframe remounts and onLoad fires (Cover ↔ Back). */
      previewLoadNonce: 0,
    };
    this.HandleSelectedStudent = this.HandleSelectedStudent.bind(this);
    this.HandleCloseSelectStudent = this.HandleCloseSelectStudent.bind(this);
  }
  HandleCloseSelectStudent = () => {
    this.setState({
      isOpenSelectStudent: false,
    });
  };

  HandleCloseSettings = () => {
    this.setState({
      isOpenSettings: false,
    });
  };

  /** After "Done" in report card settings modal: close and full reload so preview URL/state refresh. */
  HandleReportCardSettingsDone = () => {
    this.setState({ isOpenSettings: false });
    window.location.reload();
  };

  HandleSelectedStudent = () => {
    let mSelectedStudent = JSON.parse(
      localStorage.getItem("SelectedMultipleStudent")
    );
    if (mSelectedStudent == null) {
      mSelectedStudent = [];
    }

    this.setState(
      {
        isOpenSelectStudent: false,
        mSelectedStudent: mSelectedStudent,
        SELECTION_TYPE: "student",
        SELECTED_STUDENT_ID: "null",
      },
      () => {
        this.setFileUrL();
      }
    );
  };
  SelectStudent = () => {
    this.setState({
      isOpenSelectStudent: true,
    });
  };

  OpenSettings = () => {
    this.setState({
      isOpenSettings: true,
    });
  };

  toggleColorDropdown = () => {
    this.setState((prevState) => ({
      isOpenColorDropdown: !prevState.isOpenColorDropdown,
    }));
  };

  HandleSelectColorOption = (index) => {
    this.setColorOptions(index);
    this.setState({ isOpenColorDropdown: false });
  };

  /** Match StudentDueList: iframe content can post { iframeHeight } to resize preview */
  handleIframeResizeMessage = (event) => {
    if (event.data && event.data.iframeHeight) {
      this.setState({
        iFrameHeight: `${event.data.iframeHeight}px`,
      });
    }
  };

  componentDidMount() {
    window.addEventListener("message", this.handleIframeResizeMessage, false);
    this.bootstrapFromRouteParams();
  }

  //Created By Cursor — re-init when navigating between report cards without full remount
  componentDidUpdate(prevProps) {
    const prev = prevProps.match?.params || {};
    const next = this.props.match?.params || {};
    if (
      prev.report_card_id !== next.report_card_id ||
      prev.exam_id !== next.exam_id ||
      prev.session_id !== next.session_id ||
      prev.student_id !== next.student_id
    ) {
      this.bootstrapFromRouteParams();
    }
  }

  bootstrapFromRouteParams = () => {
    const params = (this.props.match && this.props.match.params) || {};
    const reportCardId = params.report_card_id || "";
    const examId = decodeURIComponent(params.exam_id || "0");
    const sessionId = params.session_id || "";
    const studentId = params.student_id || "null";

    if (!reportCardId || !sessionId) {
      console.warn(
        "ExamStudentReportCard: missing route params",
        params
      );
    }

    this.setState(
      {
        REPORT_CARD_ID: reportCardId,
        EXAM_ID: examId,
        SESSION_ID: sessionId,
        SELECTED_STUDENT_ID: studentId,
        showPreview: false,
        FILE_URL: "",
        //Created By Cursor — Back Page (process report) selected by default
        reportPageType: "BACK_PAGE",
        isCoverPageEnabled: false,
      },
      () => {
        this.getReportCardSettings();
        this.getReportCardCoverSettings();
        this.getPrintableSamples();
      }
    );
  };

  componentWillUnmount() {
    window.removeEventListener("message", this.handleIframeResizeMessage, false);
  }

  getReportCardSettings() {
    this.setState({
      Loading: true,
    });

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getReportCardSettings.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;
    //alert(URL);

    //console.log("URL>>>>>"+URL);
    const params = {
      school_code: SCHOOL_CODE,
      report_card_id: this.state.REPORT_CARD_ID,
      session_id: this.state.SESSION_ID,
    };
    const queryString = new URLSearchParams(params).toString();
    if (process.env.NODE_ENV === "development") {
      console.log("Full URL: ", `${URL}${queryString}`);
    }

    axios
      .get(URL, {
        params: params,
      })
      .then((res) => res.data)
      .then((response) => {
        this.setState({
          Loading: false,
        });
        //console.log("Response2>>>>>"+response);
        let api_status = response.api_status;
        //alert(JSON.stringify(response));

        if (api_status == "OK") {
          const settingsArray = Array.isArray(response.data)
            ? response.data
            : [];
          const row0 =
            settingsArray && settingsArray.length > 0
              ? settingsArray[0]
              : null;
          const acp = row0 && row0.active_cover_page;
          const needCover =
            acp === "1" || acp === 1 || acp === true;
          this.setState({
            mSettings: settingsArray,
            mSettingsLocal: row0 ? { ...row0 } : null,
            needCoverPageBothSide: !!needCover,
          });
          const manualAttendance =
            response?.data?.[0]?.manual_attendance !== undefined
              ? response.data[0].manual_attendance
              : "";
          this.setState({
            MANUAL_ATTENDANCE: manualAttendance,
          });
          //alert( this.state.MANUAL_ATTENDANCE);
          //alert("mSamples>>>>>"+JSON.stringify(this.state.mSamples));
        } else {
          let api_remark = response.api_remark;
          myToast.notify_warning(api_remark);
        }
      })
      .catch((error) => {
        this.setState({
          Loading: false,
        });
        console.log("error>>>>>" + error);
      });
  }

  getReportCardCoverSettings() {
    this.setState({
      Loading: true,
    });

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getReportCardCoverSettings.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;
    const params = {
      school_code: SCHOOL_CODE,
      report_card_id: this.state.REPORT_CARD_ID,
      session_id: this.state.SESSION_ID,
    };

    axios
      .get(URL, {
        params: params,
      })
      .then((res) => res.data)
      .then((response) => {
        this.setState({
          Loading: false,
        });
        let api_status = response.api_status;

        if (api_status == "OK") {
          const settingsArray = Array.isArray(response.data)
            ? response.data
            : [];
          const row0 =
            settingsArray && settingsArray.length > 0
              ? settingsArray[0]
              : null;
          this.setState({
            mCoverSettings: settingsArray,
            mCoverSettingsLocal: row0 ? { ...row0 } : null,
          });
        } else {
          let api_remark = response.api_remark;
          myToast.notify_warning(api_remark);
        }
      })
      .catch((error) => {
        this.setState({
          Loading: false,
        });
        console.log("error>>>>>" + error);
      });
  }

  getPrintableSamples() {
    this.setState({
      Loading: true,
    });
    var document_type = "ANNUAL_REPORT_CARD";
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getPrintableSample.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;
    // alert(URL);
    const params = {
      school_code: SCHOOL_CODE,
      document_type: document_type,
    };
    const queryString = new URLSearchParams(params).toString();
    //console.log("Full URL: ", `${URL}${queryString}`);

    axios
      .get(URL, {
        params: params,
      })
      .then((res) => res.data)
      .then((response) => {
        this.setState({
          Loading: false,
        });
        //console.log("Response2>>>>>"+response);
        let api_status = response.api_status;
        //alert(JSON.stringify(response));

        if (api_status == "OK") {
          this.setState({
            mSamples: response.data,
          });
          //alert("mSamples>>>>>"+JSON.stringify(this.state.mSamples));
          this.setSample(this.state.SELECTED_SAMPLE_POSITION);
        } else {
          let api_remark = response.api_remark;
          myToast.notify_warning(api_remark);
        }
      })
      .catch((error) => {
        this.setState({
          Loading: false,
        });
        console.log("error>>>>>" + error);
      });
  }

  /**
   * Load cover-page templates when user selects Cover Page (document_type report_card_cover).
   */
  getCoverPrintableSamples = () => {
    this.setState({ loadingCoverSamples: true });
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getPrintableSample.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;
    const params = {
      school_code: SCHOOL_CODE,
      document_type: DOCUMENT_TYPE_REPORT_CARD_COVER,
    };

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        if (response.api_status === "OK") {
          const list = Array.isArray(response.data) ? response.data : [];
          const first = list.length > 0 ? list[0] : null;
          this.setState(
            {
              loadingCoverSamples: false,
              mCoverSamples: list,
              COVER_SAMPLE_POSITION: 0,
              COVER_SAMPLE_ID: first ? first.sample_id || "" : "",
            },
            () => {
              const canPreview =
                this.state.SELECTED_STUDENT_ID !== "null" ||
                this.state.SELECTION_TYPE === "student";
              if (canPreview) {
                this.setFileUrL();
              }
            }
          );
        } else {
          this.setState({
            loadingCoverSamples: false,
            mCoverSamples: [],
            COVER_SAMPLE_ID: "",
          });
          myToast.notify_warning(
            response?.api_remark || "No cover page samples available"
          );
        }
      })
      .catch((error) => {
        this.setState({ loadingCoverSamples: false, mCoverSamples: [] });
        console.error("getCoverPrintableSamples error:", error);
        myToast.notify_error("Failed to load cover page samples");
      });
  };

  setSample(selected_sample_position) {
    const sample =
      this.state.mSamples && this.state.mSamples.length > 0
        ? this.state.mSamples[selected_sample_position]
        : null;

    if (!sample) {
      this.setState({
        FILE_NAME: "",
        FILE_DIRECTORY: "",
        SELECTED_SAMPLE_ID: "",
        mColorOption: [],
        COLOR_OPTION_ID: "",
      });
      return;
    }

    this.setState(
      {
        FILE_NAME: sample.file_name || "",
        FILE_DIRECTORY: sample.file_directory || "",
        SELECTED_SAMPLE_ID: sample.sample_id || "",
        mColorOption: Array.isArray(sample.color_options)
          ? sample.color_options
          : [],
        SELECTED_COLOR_OPTION_POSITION: 0,
        isOpenColorDropdown: false,
      },
      () => {
        this.setColorOptions(0);
      }
    );
  }

  getColorOptions(selected_sample_position) {
    // legacy method kept for compatibility; new flow sets color options in `setSample`
    const sample =
      this.state.mSamples && this.state.mSamples.length > 0
        ? this.state.mSamples[selected_sample_position]
        : null;
    const colorOptions =
      sample && Array.isArray(sample.color_options) ? sample.color_options : [];

    this.setState(
      {
        mColorOption: colorOptions,
        SELECTED_COLOR_OPTION_POSITION: 0,
        isOpenColorDropdown: false,
      },
      () => this.setColorOptions(0)
    );
  }
  setColorOptions(selected_position_color_option) {
    const mColorOption = this.state.mColorOption || [];
    const colorOptionId =
      mColorOption.length > 0
        ? mColorOption[selected_position_color_option]?.color_option_id || ""
        : "";

    this.setState(
      {
        COLOR_OPTION_ID: colorOptionId,
        SELECTED_COLOR_OPTION_POSITION: selected_position_color_option,
      },
      () => {
        if (this.state.SELECTED_STUDENT_ID !== "null") {
          this.setFileUrL();
          return;
        }
        if (this.state.SELECTION_TYPE === "student") {
          this.setFileUrL();
        }
      }
    );
  }

  // Cover page helpers
  toggleCoverPage = () => {
    this.setState(
      (prevState) => ({
        isCoverPageEnabled: !prevState.isCoverPageEnabled,
        reportPageType: !prevState.isCoverPageEnabled ? "COVER_PAGE" : "BACK_PAGE",
      }),
      () => {
        if (
          this.state.SELECTED_STUDENT_ID !== "null" ||
          this.state.SELECTION_TYPE === "student"
        ) {
          this.setFileUrL();
        }
      }
    );
  };

  changeCoverSample = (position) => {
    const list = this.state.mCoverSamples || [];
    const sample =
      list.length > 0 ? list[position] : null;

    if (!sample) {
      return;
    }

    this.setState(
      {
        COVER_SAMPLE_POSITION: position,
        COVER_SAMPLE_ID: sample.sample_id || "",
      },
      () => {
        if (
          this.state.SELECTED_STUDENT_ID !== "null" ||
          this.state.SELECTION_TYPE === "student"
        ) {
          this.setFileUrL();
        }
      }
    );
  };

  changeReportPageType = (type) => {
    const isCover = type === "COVER_PAGE";
    this.setState(
      {
        reportPageType: type,
        isCoverPageEnabled: isCover,
      },
      () => {
        if (isCover) {
          // Reload cover templates (report_card_cover) and refresh preview after selection
          this.getCoverPrintableSamples();
          this.getReportCardCoverSettings();
        } else {
          this.getReportCardSettings();
          const canPreview =
            this.state.SELECTED_STUDENT_ID !== "null" ||
            this.state.SELECTION_TYPE === "student";
          if (canPreview) {
            this.setFileUrL();
          }
        }
      }
    );
  };

  toggleReportSetting = (key) => {
    this.setState((prevState) => {
      const isCover = prevState.reportPageType === "COVER_PAGE";
      const settingsSource = isCover
        ? prevState.mCoverSettingsLocal || prevState.mSettingsLocal
        : prevState.mSettingsLocal;
      if (!settingsSource) return null;
      const current = settingsSource[key];
      const nextVal =
        String(current) === "1" || current === 1 || current === true ? 0 : 1;
      if (isCover) {
        return {
          mCoverSettingsLocal: {
            ...(prevState.mCoverSettingsLocal || prevState.mSettingsLocal || {}),
            [key]: nextVal,
          },
        };
      }
      return {
        mSettingsLocal: {
          ...prevState.mSettingsLocal,
          [key]: nextVal,
        },
      };
    });
  };

  //Created By Cursor — non-toggle settings (attendance_month, rank_based_on, etc.)
  handleReportSettingFieldChange = (key, value) => {
    this.setState((prevState) => {
      if (!prevState.mSettingsLocal) return null;
      return {
        mSettingsLocal: {
          ...prevState.mSettingsLocal,
          [key]: value,
        },
      };
    });
  };

  /** POST changed toggle fields to saveReportCardSettings.php, then refresh settings */
  handleSaveReportSettings = () => {
    const staff = SessionManager.getStaffDetails();
    const STAFF_ID = staff && staff.staff_id ? staff.staff_id : "";
    if (!STAFF_ID) {
      myToast.notify_warning("Staff session not found. Please sign in again.");
      return;
    }
    const isCover = this.state.reportPageType === "COVER_PAGE";
    const original = isCover
      ? this.state.mCoverSettings &&
        Array.isArray(this.state.mCoverSettings) &&
        this.state.mCoverSettings.length > 0
        ? this.state.mCoverSettings[0]
        : null
      : this.state.mSettings &&
        Array.isArray(this.state.mSettings) &&
        this.state.mSettings.length > 0
      ? this.state.mSettings[0]
      : null;
    const localSettings = isCover
      ? this.state.mCoverSettingsLocal || this.state.mSettingsLocal
      : this.state.mSettingsLocal;
    if (!original || !localSettings) {
      myToast.notify_warning("No settings to save.");
      return;
    }
    const diff = {};
    Object.keys(localSettings).forEach((key) => {
      if (
        key === "id" ||
        key === "eet" ||
        key === "eeg" ||
        key === "show_co_schoolistic_activity" ||
        key === "active_cover_page"
      ) {
        return;
      }
      const newVal = localSettings[key];
      const oldVal = original[key];
      if (typeof newVal === "object" && newVal !== null) return;
      if (typeof oldVal === "object" && oldVal !== null) return;
      //Created By Cursor — allow save when DB value was null/empty; empty attendance_month → null
      const next = newVal === null || newVal === undefined ? "" : String(newVal);
      const prev = oldVal === null || oldVal === undefined ? "" : String(oldVal);
      if (next !== prev) {
        if (key === "attendance_month" && next.trim() === "") {
          diff[key] = null;
        } else {
          diff[key] = newVal === null || newVal === undefined ? "" : newVal;
        }
      }
    });
    if (Object.keys(diff).length === 0) {
      myToast.notify_info("No changes to save.");
      return;
    }

    const FUNCTION_NAME = isCover
      ? "saveReportCardCoverSettings.php"
      : "saveReportCardSettings.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;
    const params = new URLSearchParams();
    params.append("staff_id", STAFF_ID);
    params.append("school_code", SessionManager.getSchoolCode());
    params.append("session_id", this.state.SESSION_ID);
    params.append("report_card_id", this.state.REPORT_CARD_ID);
    params.append("settings_json", JSON.stringify(diff));

    this.setState({ savingReportSettings: true });
    axios
      .post(URL, params)
      .then((res) => res.data)
      .then((response) => {
        if (response.api_status === "OK") {
          myToast.notify_success(
            response.api_remark ||
              (isCover
                ? "Report card cover settings saved"
                : "Report card settings saved")
          );
          //Created By Cursor — reload settings + preview iframe URL (not full page)
          const refreshPreview = () => {
            const canPreview =
              this.state.SELECTED_STUDENT_ID !== "null" ||
              this.state.SELECTION_TYPE === "student";
            if (canPreview) {
              this.setFileUrL();
            }
          };
          if (isCover) {
            this.getReportCardCoverSettings();
          } else {
            this.getReportCardSettings();
          }
          refreshPreview();
        } else {
          myToast.notify_error(
            response.api_remark ||
              (isCover
                ? "Could not save report card cover settings"
                : "Could not save report card settings")
          );
        }
      })
      .catch(() => {
        myToast.notify_error("Network error while saving settings.");
      })
      .finally(() => {
        this.setState({ savingReportSettings: false });
      });
  };

  /** Need Cover Page (Both Side): local only + preview URL; use Save Settings to persist */
  handleNeedCoverPageBothSideChange = (e) => {
    const checked = e.target.checked;
    this.setState(
      (prev) => ({
        needCoverPageBothSide: checked,
        mSettingsLocal: prev.mSettingsLocal
          ? { ...prev.mSettingsLocal, active_cover_page: checked ? 1 : 0 }
          : null,
      }),
      () => {
        const canPreview =
          this.state.SELECTED_STUDENT_ID !== "null" ||
          this.state.SELECTION_TYPE === "student";
        if (canPreview) {
          this.setFileUrL();
        }
      }
    );
  };

  setFileUrL() {
    var class_id = "";
    var section_id = "";
    var session_id = "";
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    var mStudentIds = [];
    if (this.state.SELECTED_STUDENT_ID != "null") {
      mStudentIds[0] = this.state.SELECTED_STUDENT_ID;
      session_id = this.state.SESSION_ID;
      // keep SELECTION_TYPE stable
    } else {
      if (this.state.SELECTION_TYPE === "student") {
        if (!this.state.mSelectedStudent || this.state.mSelectedStudent.length === 0) {
          myToast.notify_warning("Please select students to generate the report card preview.");
          this.setState({
            FILE_URL: "",
            showPreview: false,
          });
          return;
        }
        for (
          let index = 0;
          index < this.state.mSelectedStudent.length;
          index++
        ) {
          const element = this.state.mSelectedStudent[index];
          var student_id = element.student_enrollment_no;
          session_id = element.session_id;
          mStudentIds[index] = student_id;
        }
        // alert(JSON.stringify(this.state.mSelectedStudent));
      }
      class_id = this.state.mSelectedStudent[0].class_id;
      section_id = this.state.mSelectedStudent[0].section_id;
    }

    const isCoverPage = this.state.reportPageType === "COVER_PAGE";
    const coverList = Array.isArray(this.state.mCoverSamples)
      ? this.state.mCoverSamples
      : [];
    const coverPos = Math.min(
      Math.max(0, this.state.COVER_SAMPLE_POSITION || 0),
      Math.max(0, coverList.length - 1)
    );
    const coverSample =
      isCoverPage && coverList.length > 0 ? coverList[coverPos] : null;

    // Back page: main annual report card template. Cover page: cover template path + ids.
    let fileName = this.state.FILE_NAME || "";
    let fileDirRaw = this.state.FILE_DIRECTORY || "";
    let sampleIdForUrl = this.state.SELECTED_SAMPLE_ID || "";
    let colorOptionForUrl = this.state.COLOR_OPTION_ID || "";

    if (isCoverPage && coverSample) {
      fileName = coverSample.file_name || fileName;
      fileDirRaw = coverSample.file_directory || fileDirRaw;
      sampleIdForUrl =
        coverSample.sample_id ||
        this.state.COVER_SAMPLE_ID ||
        sampleIdForUrl;
      const coverColors = Array.isArray(coverSample.color_options)
        ? coverSample.color_options
        : [];
      if (coverColors.length > 0) {
        const cIdx = Math.min(
          this.state.SELECTED_COLOR_OPTION_POSITION || 0,
          coverColors.length - 1
        );
        colorOptionForUrl =
          coverColors[cIdx]?.color_option_id ||
          coverColors[0]?.color_option_id ||
          "";
      }
    }

    const dir =
      fileDirRaw && fileDirRaw.length > 0
        ? fileDirRaw.endsWith("/")
          ? fileDirRaw
          : fileDirRaw + "/"
        : "";

    const coverSampleId = isCoverPage
      ? this.state.COVER_SAMPLE_ID || coverSample?.sample_id || ""
      : "";

    const needCoverPage = this.state.needCoverPageBothSide ? 1 : 0;

    // When showing cover, pass main report sample id separately for PHP that needs both.
    const reportSampleId =
      isCoverPage && this.state.SELECTED_SAMPLE_ID
        ? this.state.SELECTED_SAMPLE_ID
        : "";

    const FILE_URL =
      process.env.REACT_APP_SERVER_NAME +
      dir +
      fileName +
      "?&student_ids=" +
      encodeURIComponent(JSON.stringify(mStudentIds)) +
      "&class_id=" +
      encodeURIComponent(class_id) +
      "&section_id=" +
      encodeURIComponent(section_id) +
      "&session_id=" +
      encodeURIComponent(session_id) +
      "&sample_id=" +
      encodeURIComponent(sampleIdForUrl) +
      "&selection_type=" +
      encodeURIComponent(this.state.SELECTION_TYPE) +
      "&report_card_id=" +
      encodeURIComponent(this.state.REPORT_CARD_ID) +
      "&report_card_type=" +
      encodeURIComponent(this.state.REPORT_CARD_TYPE) +
      "&color_option_id=" +
      encodeURIComponent(colorOptionForUrl) +
      "&page_type=" +
      encodeURIComponent(this.state.reportPageType) +
      "&cover_sample_id=" +
      encodeURIComponent(coverSampleId) +
      "&report_sample_id=" +
      encodeURIComponent(reportSampleId) +
      "&active_cover_page=" +
      encodeURIComponent(needCoverPage) +
      "&system_code=" +
      encodeURIComponent(process.env.REACT_APP_SYSTEM_CODE) +
      "&school_code=" +
      encodeURIComponent(SCHOOL_CODE);

    if (process.env.NODE_ENV === "development") {
      console.log("FILE_URL", FILE_URL);
    }

    this.setState((prev) => ({
      FILE_URL: FILE_URL,
      showPreview: true,
      previewLoadNonce: (prev.previewLoadNonce || 0) + 1,
    }));
  }

  handlePreviewIframeLoad = () => {
    this.setState({ showPreview: false });
  };

  changeSample(position) {
    this.setState(
      {
        SELECTED_SAMPLE_POSITION: position,
      },
      () => {
        // alert(this.state.SELECTED_SAMPLE_POSITION);
        this.setSample(this.state.SELECTED_SAMPLE_POSITION);
      }
    );
  }
  changeColorOption(position) {
    this.setColorOptions(position);
  }

  render() {
    if (this.state.loggedIn == false) {
      return <Redirect to="/Login" />;
    }

    const { mColorOption, SELECTED_COLOR_OPTION_POSITION, Loading } = this.state;
    const selectedColorOption =
      mColorOption && mColorOption.length > 0
        ? mColorOption[SELECTED_COLOR_OPTION_POSITION] || mColorOption[0]
        : null;

    return (
      <>
        {Loading ? <MyLoader /> : null}
        <div
          className="content"
          style={{ background: COLORS.whitesmoke }}
        >
                    <style>{`
                      .rs-header-gradient{background: linear-gradient(135deg, #4f46e5 0%, #2563eb 100%);} 
                      .report-action-btn{background: linear-gradient(135deg,#3b82f6 0%,#2563eb 100%); border:1px solid #e5e7eb; border-radius:12px; box-shadow:0 4px 10px rgba(37,99,235,.25); cursor:pointer; transition: transform .16s ease, box-shadow .16s ease, background .16s ease, border-color .16s ease}
                      .report-action-btn .inner{display:flex;align-items:center;justify-content:center;gap:0;height:40px;line-height:1;padding:8px 12px}
                      .report-action-btn:hover,.report-action-btn:focus{transform: translateY(-2px); box-shadow:0 8px 18px rgba(37,99,235,.28); border-color:#dbeafe; background: linear-gradient(135deg,#60a5fa 0%, #3b82f6 100%)}
                      .report-action-btn:active{transform: translateY(0); box-shadow:0 4px 10px rgba(37,99,235,.22); background: linear-gradient(135deg,#3b82f6 0%, #2563eb 100%)}
                      .report-action-btn .inner span{display:inline-flex;align-items:center;color:#fff;font-weight:700;letter-spacing:.2px;font-size:13.5px;line-height:1}
                      .report-action-btn .icon,.report-action-btn i,.report-action-btn svg{display:none !important}
                      .sample-card{border-radius:12px; box-shadow:0 3px 8px rgba(0,0,0,.08); transition:transform .15s ease}
                      .sample-card.selected{outline:2px solid #10b981; box-shadow:0 6px 14px rgba(16,185,129,.25)}
                      .sample-card:hover{transform:translateY(-2px)}
                      .color-card{border-radius:10px; box-shadow:0 2px 6px rgba(0,0,0,.08);}
                      .color-card.selected{outline:2px solid #10b981}
                      .preview-card{border-radius:12px; overflow:hidden; box-shadow:0 6px 16px rgba(0,0,0,.12); border:1px solid #e5e7eb}
                    `}</style>
                    <div className="content-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i className="fa fa-home" aria-hidden="true" />
              <a href="#">Student Reportcard</a>
            </li>
          </ul>
        </div>
        <div>
          <BackButton />
        </div>
      </div>

                    <div
                      className="animated fadeInUpn bg_page_white_rounded box_shadow"
                      style={{ "--mMargin": "20px" ,padding:"0px"}}
                    >
                      {/* Page Title inside content card */}
                      <div
                        className="row"
                        style={{
                          margin: "0px 0px 5px 0px",
                          padding: "12px 10px 8px 10px",
                          borderBottom: `1px solid ${COLORS.primary_color_shade6}`,
                          borderRadius: "10px 10px 0 0",
                          background: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade5} 45%, ${COLORS.primary_color_shade4} 100%)`,
                        }}
                      >
                        <div className="col-12 col-md-8 col-lg-9 padding_0">
                          <h3
                            style={{
                              margin: 0,
                              fontSize: "18px",
                              fontWeight: 700,
                              color: "#ffffff",
                            }}
                          >
                            Student Exam Report Card
                          </h3>
                          <p
                            style={{
                              margin: "2px 0 0 0",
                              fontSize: "12px",
                              color: "rgba(249,250,251,0.85)",
                            }}
                          >
                            Configure layout, colors and generate printable report cards for selected students.
                          </p>
                        </div>
                        <div className="col-12 col-md-4 col-lg-3 padding_0">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              height: "100%",
                              gap: "8px",
                              flexWrap: "nowrap",
                            }}
                          >
                            <button
                              type="button"
                              onClick={this.OpenSettings}
                              style={{
                                borderRadius: "999px",
                                border: "1px solid rgba(249,250,251,0.55)",
                                padding: "6px 14px",
                                background: "rgba(15,23,42,0.35)",
                                color: "#e5e7eb",
                                fontSize: "12px",
                                fontWeight: 700,
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                cursor: "pointer",
                                height: "34px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <i className="fa fa-sliders" />
                              <span style={{ letterSpacing: "0.4px", textTransform: "uppercase" }}>
                                Customise
                              </span>
                            </button>
                            <button
                              type="button"
                              onClick={this.SelectStudent}
                              style={{
                                borderRadius: "999px",
                                border: "2px solid #facc15",
                                padding: "6px 24px",
                                minWidth: "170px",
                                background:
                                  "linear-gradient(135deg, #facc15 0%, #f97316 50%, #ea580c 100%)",
                                color: "#ffffff",
                                fontSize: "12px",
                                fontWeight: 700,
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                cursor: "pointer",
                                boxShadow: "0 4px 10px rgba(15,23,42,0.5)",
                                height: "34px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <i className="fa fa-user-plus" />
                              <span style={{ letterSpacing: "0.4px", textTransform: "uppercase" }}>
                                Select Students
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        className="row"
                        style={{ margin: "0px 10px 0px 10px" }}
                      >
                        <div className="col-sm-2 col-lg-2 padding_0">
                          <Link
                            to={
                              "/AdminMain/ExamReportCardRankList/" +
                              this.state.REPORT_CARD_ID +
                              "/" +
                              this.state.SESSION_ID
                            }
                          >
                            <div className="report-action-btn gravity_center_vertical" style={{margin:"0 5px 0 0"}}>
                              <div className="inner">
                                <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3h18v4H3z"/><path d="M7 7v14"/><path d="M12 7v14"/><path d="M17 7v14"/></svg>
                                <span>View Rank List</span>
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className="col-sm-2 col-lg-2 padding_0 height_match_parent">
                          <Link
                            to={
                              "/AdminMain/ExamReportCardAttendanceReport/" +
                              this.state.REPORT_CARD_ID +
                              "/" +
                              this.state.SESSION_ID +
                              "/" +
                              this.state.MANUAL_ATTENDANCE
                            }
                          >
                            <div className="report-action-btn gravity_center_vertical" style={{margin:"0 5px 0 0"}}>
                              <div className="inner">
                                <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
                                <span>View Attendance</span>
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className="col-sm-2 col-lg-2 padding_0 height_match_parent">
                          <Link
                            to={
                              "/AdminMain/SchoolWorkingDays/" +
                              this.state.REPORT_CARD_ID +
                              "/" +
                              this.state.SESSION_ID
                            }
                          >
                            <div className="report-action-btn gravity_center_vertical" style={{margin:"0 5px 0 0"}}>
                              <div className="inner">
                                <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                                <span>Working Days</span>
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className="col-sm-2 col-lg-2 padding_0 height_match_parent">
                          <Link
                            to={
                              "/AdminMain/ExamMarkingSystemAnnual/" +
                              this.state.REPORT_CARD_ID +
                              "/" +
                              this.state.SESSION_ID
                            }
                          >
                            <div className="report-action-btn gravity_center_vertical" style={{margin:"0 5px 0 0"}}>
                              <div className="inner">
                                <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 20l9-5-9-5-9 5 9 5z"/><path d="M12 12l9-5-9-5-9 5 9 5z"/></svg>
                                <span>Performance Descriptor</span>
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className="col-sm-2 col-lg-2 padding_0 height_match_parent">
                          <Link
                            to={
                              "/AdminMain/ExamReportCardCrossList/" +
                              this.state.REPORT_CARD_ID +
                              "/" +
                              this.state.SESSION_ID
                            }
                          >
                            <div className="report-action-btn gravity_center_vertical" style={{margin:"0 5px 0 0"}}>
                              <div className="inner">
                                <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16v16H4z"/><path d="M4 10h16"/><path d="M10 4v16"/></svg>
                                <span>Cross List</span>
                              </div>
                            </div>
                          </Link>
                        </div>

                        <div className="col-sm-2 col-lg-2 padding_0 height_match_parent">
                          <Link
                            to={
                              "/AdminMain/ExamReportCardGauzzat/" +
                              this.state.REPORT_CARD_ID +
                              "/" +
                              this.state.SESSION_ID
                            }
                          >
                            <div className="report-action-btn gravity_center_vertical" style={{margin:"0 5px 0 0"}}>
                              <div className="inner">
                                <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v8M8 12h8"/></svg>
                                <span>Gauzzat</span>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                      {/* Report page type selector row - two buttons */}
                      <div
                        className="selection-section"
                        style={{ margin: "16px 20px 0 20px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "12px",
                            flexWrap: "wrap",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                              flexWrap: "wrap",
                            }}
                          >
                            <h5
                              className="section-title"
                              style={{
                                marginBottom: 0,
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <i
                                className="fa fa-layer-group"
                                style={{ marginRight: "6px" }}
                              />
                              Report Card Page Type
                            </h5>
                            <label
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                fontSize: "12px",
                                cursor: "pointer",
                                padding: "5px 14px",
                                borderRadius: "999px",
                                backgroundColor: this.state.needCoverPageBothSide
                                  ? "#ecfdf3"
                                  : "#f9fafb",
                                border: this.state.needCoverPageBothSide
                                  ? "1px solid #16a34a"
                                  : "1px solid #e5e7eb",
                                boxShadow: this.state.needCoverPageBothSide
                                  ? "0 0 0 1px rgba(22,163,74,0.35)"
                                  : "none",
                                marginTop: "0",
                                marginBottom: "0",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={this.state.needCoverPageBothSide}
                                onChange={this.handleNeedCoverPageBothSideChange}
                                style={{ cursor: "pointer" }}
                              />
                              <span
                                style={{
                                  fontWeight: 700,
                                  color: this.state.needCoverPageBothSide
                                    ? "#166534"
                                    : "#374151",
                                  letterSpacing: 0.2,
                                  lineHeight: 1.2,
                                }}
                              >
                                Need Cover Page (Both Side)
                              </span>
                            </label>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              flexWrap: "wrap",
                            }}
                          >
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.changeReportPageType("BACK_PAGE");
                                }}
                                style={{
                                  borderRadius: "999px",
                                  padding: "6px 14px",
                                  fontSize: "12px",
                                  fontWeight: 700,
                                  border:
                                    this.state.reportPageType === "BACK_PAGE"
                                      ? "2px solid #3b82f6"
                                      : "1px solid #3b82f6",
                                  background:
                                    this.state.reportPageType === "BACK_PAGE"
                                      ? "linear-gradient(135deg,#3b82f6 0%,#2563eb 100%)"
                                      : "#ffffff",
                                  color:
                                    this.state.reportPageType === "BACK_PAGE"
                                      ? "#ffffff"
                                      : "#1f2933",
                                  boxShadow:
                                    this.state.reportPageType === "BACK_PAGE"
                                      ? "0 4px 10px rgba(37,99,235,0.35)"
                                      : "none",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  cursor: "pointer",
                                }}
                              >
                                <i className="fa fa-file-alt" />
                                <span>Back Page (Process Report)</span>
                              </button>
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.changeReportPageType("COVER_PAGE");
                                }}
                                style={{
                                  borderRadius: "999px",
                                  padding: "6px 14px",
                                  fontSize: "12px",
                                  fontWeight: 700,
                                  border:
                                    this.state.reportPageType === "COVER_PAGE"
                                      ? "2px solid #10b981"
                                      : "1px solid #10b981",
                                  background:
                                    this.state.reportPageType === "COVER_PAGE"
                                      ? "linear-gradient(135deg,#10b981 0%,#059669 100%)"
                                      : "#ffffff",
                                  color:
                                    this.state.reportPageType === "COVER_PAGE"
                                      ? "#ffffff"
                                      : "#064e3b",
                                  boxShadow:
                                    this.state.reportPageType === "COVER_PAGE"
                                      ? "0 4px 10px rgba(16,185,129,0.35)"
                                      : "none",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  cursor: "pointer",
                                }}
                              >
                                <i className="fa fa-file" />
                                <span>Cover Page (Front)</span>
                              </button>
                          </div>
                        </div>
                      </div>

                      {/* Samples + Color options compact row */}
                      <div
                        className="row"
                        style={{
                          margin: "6px 10px 6px 10px",
                          backgroundColor: "#ffffff",
                          borderRadius: "12px",
                          boxShadow: "0 6px 18px rgba(15,23,42,0.18)",
                          padding: "8px 10px 6px 10px",
                        }}
                      >
                        <div className="col-sm-10 col-lg-10 padding_0">
                          <div
                            style={{
                              padding: "5px 0 2px 0",
                              color: "#000",
                            }}
                          >
                            <h5
                              className=""
                              style={{ margin: 0, fontSize: "13px", fontWeight: 700 }}
                            >
                              Sample List
                            </h5>
                          </div>
                          <div
                            className="row"
                            style={{ margin: "0px 0px 0px 0px", padding: "2px 0" }}
                          >
                            {this.state.mSamples &&
                              this.state.mSamples.map((item, index) => (
                                <div className="col-sm-4 col-lg-4 padding_0" key={item.sample_id || index}>
                                  <div
                                    className={
                                      "sample-card " +
                                      (this.state.SELECTED_SAMPLE_POSITION == index
                                        ? "selected"
                                        : "")
                                    }
                                    style={{
                                      margin: "3px 6px",
                                      padding: "6px 10px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      cursor: "pointer",
                                      height: "34px",
                                      borderRadius: "10px",
                                      backgroundColor: "#ffffff",
                                      boxShadow: "0 2px 6px rgba(15,23,42,0.10)",
                                    }}
                                    onClick={(e) => this.changeSample(index)}
                                    title={item.sample_name}
                                  >
                                    <i
                                      className="fa fa-check-circle"
                                      style={{
                                        fontSize: "12px",
                                        color:
                                          this.state.SELECTED_SAMPLE_POSITION == index
                                            ? "#22c55e"
                                            : "#9ca3af",
                                      }}
                                    />
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        fontWeight:
                                          this.state.SELECTED_SAMPLE_POSITION == index
                                            ? 700
                                            : 500,
                                        color: COLORS.primary_color_shade7,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {item.sample_name}
                                    </span>
                                  </div>
                                </div>
                              ))}
                          </div>

                          {this.state.isCoverPageEnabled && (
                            <div style={{ marginTop: "12px" }}>
                              <h5
                                className=""
                                style={{
                                  margin: "4px 0 6px 0",
                                  fontSize: "13px",
                                  fontWeight: 700,
                                  color: "#0f766e",
                                }}
                              >
                                Cover Page Sample List
                                <span
                                  style={{
                                    fontSize: "11px",
                                    fontWeight: 500,
                                    color: "#64748b",
                                    marginLeft: "8px",
                                  }}
                                >
                                  ({DOCUMENT_TYPE_REPORT_CARD_COVER})
                                </span>
                              </h5>
                              {this.state.loadingCoverSamples ? (
                                <div
                                  style={{
                                    padding: "12px",
                                    fontSize: "12px",
                                    color: "#64748b",
                                  }}
                                >
                                  Loading cover page templates…
                                </div>
                              ) : !this.state.mCoverSamples ||
                                this.state.mCoverSamples.length === 0 ? (
                                <div
                                  style={{
                                    padding: "10px 12px",
                                    fontSize: "12px",
                                    color: "#b45309",
                                    background: "#fffbeb",
                                    borderRadius: "8px",
                                    border: "1px solid #fde68a",
                                  }}
                                >
                                  No cover page templates found. Add samples for
                                  document type{" "}
                                  <strong>{DOCUMENT_TYPE_REPORT_CARD_COVER}</strong>{" "}
                                  in printable settings.
                                </div>
                              ) : (
                                <div
                                  className="row"
                                  style={{
                                    margin: "0px 0px 0px 0px",
                                    padding: "2px 0",
                                  }}
                                >
                                  {this.state.mCoverSamples.map((item, index) => (
                                    <div
                                      className="col-sm-4 col-lg-4 padding_0"
                                      key={`cover-${item.sample_id || index}`}
                                    >
                                      <div
                                        className={
                                          "sample-card " +
                                          (this.state.COVER_SAMPLE_POSITION ===
                                          index
                                            ? "selected"
                                            : "")
                                        }
                                        style={{
                                          margin: "3px 6px",
                                          padding: "6px 10px",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                          cursor: "pointer",
                                          height: "34px",
                                          borderRadius: "10px",
                                          backgroundColor: "#ffffff",
                                          boxShadow:
                                            "0 2px 6px rgba(15,23,42,0.10)",
                                        }}
                                        onClick={() =>
                                          this.changeCoverSample(index)
                                        }
                                        title={item.sample_name}
                                      >
                                        <i
                                          className="fa fa-check-circle"
                                          style={{
                                            fontSize: "12px",
                                            color:
                                              this.state.COVER_SAMPLE_POSITION ===
                                              index
                                                ? "#22c55e"
                                                : "#9ca3af",
                                          }}
                                        />
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            fontWeight:
                                              this.state.COVER_SAMPLE_POSITION ===
                                              index
                                                ? 700
                                                : 500,
                                            color: COLORS.primary_color_shade7,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {item.sample_name}
                                        </span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        <div className="col-sm-2 col-lg-2 padding_0">
                          <div
                            style={{
                              padding: "5px 0 2px 10px",
                              color: "#000",
                            }}
                          >
                            <h5 className="" style={{ margin: 0, fontSize: "13px", fontWeight: 700 }}>
                              Color Options
                            </h5>
                          </div>
                          <div style={{ padding: "4px 10px 0 10px", position: "relative" }}>
                            <div
                              onClick={this.toggleColorDropdown}
                              style={{
                                height: "32px",
                                borderRadius: "8px",
                                border: "1px solid #d1d5db",
                                padding: "4px 8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                cursor: "pointer",
                                backgroundColor: "#ffffff",
                                fontSize: "12px",
                              }}
                            >
                              {selectedColorOption ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    overflow: "hidden",
                                  }}
                                >
                                  {(() => {
                                    const parts = (selectedColorOption.sample_color_code || "").split("_");
                                    const c1 = parts[0] || "#ffffff";
                                    const c2 = parts[1] || "#ffffff";
                                    return (
                                      <>
                                        <div
                                          style={{
                                            width: "14px",
                                            height: "14px",
                                            borderRadius: "50%",
                                            backgroundColor: c1,
                                            border: "1px solid #e5e7eb",
                                          }}
                                        />
                                        <div
                                          style={{
                                            width: "14px",
                                            height: "14px",
                                            borderRadius: "50%",
                                            backgroundColor: c2,
                                            border: "1px solid #e5e7eb",
                                          }}
                                        />
                                      </>
                                    );
                                  })()}
                                  <span
                                    style={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {selectedColorOption.sample_color_name}
                                  </span>
                                </div>
                              ) : (
                                <span style={{ color: "#9ca3af" }}>Select color</span>
                              )}
                              <i
                                className="fa fa-chevron-down"
                                style={{ fontSize: "10px", color: "#6b7280" }}
                              />
                            </div>

                            {/* Custom dropdown list with color circles and names */}
                            {this.state.isOpenColorDropdown &&
                              this.state.mColorOption &&
                              this.state.mColorOption.length > 0 && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "100%",
                                    right: 0,
                                    marginTop: "4px",
                                    backgroundColor: "#ffffff",
                                    borderRadius: "8px",
                                    boxShadow: "0 8px 20px rgba(15,23,42,0.25)",
                                    padding: "4px 0",
                                    maxHeight: "220px",
                                    overflowY: "auto",
                                    width: "220px",
                                    zIndex: 20,
                                  }}
                                >
                                  {this.state.mColorOption.map((item, index) => {
                                    const parts = (item.sample_color_code || "").split("_");
                                    const c1 = parts[0] || "#ffffff";
                                    const c2 = parts[1] || "#ffffff";
                                    const isSelected =
                                      this.state.SELECTED_COLOR_OPTION_POSITION == index;
                                    return (
                                      <div
                                        key={item.color_option_id || index}
                                        onClick={() => this.HandleSelectColorOption(index)}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                          padding: "4px 10px",
                                          cursor: "pointer",
                                          backgroundColor: isSelected ? "#eff6ff" : "#ffffff",
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: "14px",
                                            height: "14px",
                                            borderRadius: "50%",
                                            backgroundColor: c1,
                                            border: "1px solid #e5e7eb",
                                          }}
                                        />
                                        <div
                                          style={{
                                            width: "14px",
                                            height: "14px",
                                            borderRadius: "50%",
                                            backgroundColor: c2,
                                            border: "1px solid #e5e7eb",
                                          }}
                                        />
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                          title={item.sample_color_name}
                                        >
                                          {item.sample_color_name}
                                        </span>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                          </div>
                        </div>
                      </div>

                      {/* Report Card Settings (from getReportCardSettings.php) — open by default once loaded */}
                      {(this.state.reportPageType === "COVER_PAGE"
                        ? this.state.mCoverSettingsLocal || this.state.mSettingsLocal
                        : this.state.mSettingsLocal) && (
                          <div
                            className="row"
                            style={{
                              margin: "6px 10px 6px 10px",
                              backgroundColor: "#ffffff",
                              borderRadius: "12px",
                              boxShadow: "0 4px 12px rgba(15,23,42,0.16)",
                              padding: "8px 10px 8px 10px",
                            }}
                          >
                            <div className="col-12 padding_0">
                              <h5
                                style={{
                                  margin: "0 0 6px 0",
                                  fontSize: "13px",
                                  fontWeight: 700,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                <i
                                  className="fa fa-sliders"
                                  style={{ marginRight: "2px" }}
                                />
                                {this.state.reportPageType === "COVER_PAGE"
                                  ? "Report Card Cover Settings"
                                  : "Report Card Settings"}
                              </h5>
                              <div
                                className="row"
                                style={{ margin: "0 -4px", fontSize: "12px" }}
                              >
                                {Object.entries(
                                  this.state.reportPageType === "COVER_PAGE"
                                    ? this.state.mCoverSettingsLocal ||
                                      this.state.mSettingsLocal ||
                                      {}
                                    : this.state.mSettingsLocal || {}
                                )
                                  .filter(([key, value]) => {
                                    if (
                                      key === "id" ||
                                      key === "eet" ||
                                      key === "eeg" ||
                                      key === "active_cover_page" ||
                                      key === "show_co_schoolistic_activity" ||
                                      key === "attendance_month" ||
                                      key === "rank_based_on" ||
                                      key === "min_passing_mark_insubject" ||
                                      key === "student_info_case"
                                    ) {
                                      return false;
                                    }
                                    return (
                                      value === "0" ||
                                      value === "1" ||
                                      value === 0 ||
                                      value === 1
                                    );
                                  })
                                  .map(([key, value]) => {
                                    const isOn =
                                      String(value) === "1" || value === 1;
                                    const label = key
                                      .replace(/_/g, " ")
                                      .replace(/\s+/g, " ")
                                      .trim()
                                      .toLowerCase()
                                      .replace(
                                        /(^|\s)\S/g,
                                        (t) => t.toUpperCase()
                                      );
                                    return (
                                      <div
                                        className="col-sm-2 col-md-2 col-lg-2 col-6 padding_0"
                                        key={key}
                                        style={{ padding: "2px 4px" }}
                                      >
                                        <div
                                          style={{
                                            borderRadius: "999px",
                                            border: "1px solid #e5e7eb",
                                            padding: "4px 8px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            gap: "6px",
                                            backgroundColor: "#f9fafb",
                                            cursor: "pointer",
                                            userSelect: "none",
                                          }}
                                          onClick={() =>
                                            this.toggleReportSetting(key)
                                          }
                                        >
                                          <span
                                            style={{
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                            title={label}
                                          >
                                            {label}
                                          </span>
                                          <span
                                            style={{
                                              fontSize: "11px",
                                              fontWeight: 700,
                                              color: isOn
                                                ? "#16a34a"
                                                : "#9ca3af",
                                            }}
                                          >
                                            {isOn ? "ON" : "OFF"}
                                          </span>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                              {/* Created By Cursor — non-toggle settings from tm_exam_report_card_settings */}
                              {this.state.reportPageType !== "COVER_PAGE" &&
                                this.state.mSettingsLocal && (
                                  <div
                                    style={{
                                      marginTop: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "12px",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    {(() => {
                                      const fieldStyle = {
                                        minWidth: "140px",
                                        borderRadius: "999px",
                                        border: "1px solid #d1d5db",
                                        padding: "4px 12px",
                                        fontSize: "12px",
                                        backgroundColor: "#f9fafb",
                                        color: "#111827",
                                      };
                                      const labelStyle = {
                                        margin: 0,
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        color: "#374151",
                                        whiteSpace: "nowrap",
                                      };
                                      const groupStyle = {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                      };
                                      const months = buildSessionMonths();
                                      const currentMonth = String(
                                        this.state.mSettingsLocal
                                          .attendance_month || ""
                                      ).trim();
                                      const monthOptions =
                                        currentMonth &&
                                        /^\d{4}-\d{2}$/.test(currentMonth) &&
                                        !months.includes(currentMonth)
                                          ? [currentMonth, ...months]
                                          : months;
                                      return (
                                        <>
                                          <div style={groupStyle}>
                                            <label
                                              htmlFor="rc_attendance_month"
                                              style={labelStyle}
                                            >
                                              Attendance Month
                                            </label>
                                            <select
                                              id="rc_attendance_month"
                                              value={
                                                this.state.mSettingsLocal
                                                  .attendance_month || ""
                                              }
                                              onChange={(e) =>
                                                this.handleReportSettingFieldChange(
                                                  "attendance_month",
                                                  e.target.value
                                                )
                                              }
                                              style={fieldStyle}
                                            >
                                              <option value="">
                                                Select month
                                              </option>
                                              {monthOptions.map((ym) => (
                                                <option key={ym} value={ym}>
                                                  {ym}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                          <div style={groupStyle}>
                                            <label
                                              htmlFor="rc_rank_based_on"
                                              style={labelStyle}
                                            >
                                              Rank Based On
                                            </label>
                                            <select
                                              id="rc_rank_based_on"
                                              value={
                                                this.state.mSettingsLocal
                                                  .rank_based_on ||
                                                "PERCENTAGE"
                                              }
                                              onChange={(e) =>
                                                this.handleReportSettingFieldChange(
                                                  "rank_based_on",
                                                  e.target.value
                                                )
                                              }
                                              style={fieldStyle}
                                            >
                                              <option value="PERCENTAGE">
                                                PERCENTAGE
                                              </option>
                                              <option value="OBTAINED_MARK">
                                                OBTAINED_MARK
                                              </option>
                                            </select>
                                          </div>
                                          <div style={groupStyle}>
                                            <label
                                              htmlFor="rc_min_passing_mark"
                                              style={labelStyle}
                                            >
                                              Min Passing Mark
                                            </label>
                                            <input
                                              id="rc_min_passing_mark"
                                              type="number"
                                              min="0"
                                              max="100"
                                              placeholder="e.g. 33"
                                              value={
                                                this.state.mSettingsLocal
                                                  .min_passing_mark_insubject ??
                                                ""
                                              }
                                              onChange={(e) =>
                                                this.handleReportSettingFieldChange(
                                                  "min_passing_mark_insubject",
                                                  e.target.value
                                                )
                                              }
                                              style={{
                                                ...fieldStyle,
                                                minWidth: "90px",
                                                width: "90px",
                                              }}
                                            />
                                          </div>
                                          <div style={groupStyle}>
                                            <label
                                              htmlFor="rc_student_info_case"
                                              style={labelStyle}
                                            >
                                              Student Info Case
                                            </label>
                                            <select
                                              id="rc_student_info_case"
                                              value={
                                                this.state.mSettingsLocal
                                                  .student_info_case || "UPPER"
                                              }
                                              onChange={(e) =>
                                                this.handleReportSettingFieldChange(
                                                  "student_info_case",
                                                  e.target.value
                                                )
                                              }
                                              style={fieldStyle}
                                            >
                                              <option value="UPPER">
                                                UPPER
                                              </option>
                                              <option value="LOWER">
                                                LOWER
                                              </option>
                                              <option value="SENTANCE">
                                                SENTANCE
                                              </option>
                                            </select>
                                          </div>
                                        </>
                                      );
                                    })()}
                                  </div>
                                )}
                              {(() => {
                                const original =
                                  this.state.reportPageType === "COVER_PAGE"
                                    ? this.state.mCoverSettings &&
                                      Array.isArray(this.state.mCoverSettings) &&
                                      this.state.mCoverSettings.length > 0
                                      ? this.state.mCoverSettings[0]
                                      : this.state.mSettings &&
                                        Array.isArray(this.state.mSettings) &&
                                        this.state.mSettings.length > 0
                                      ? this.state.mSettings[0]
                                      : null
                                    : this.state.mSettings &&
                                      Array.isArray(this.state.mSettings) &&
                                      this.state.mSettings.length > 0
                                    ? this.state.mSettings[0]
                                    : null;
                                const localSettings =
                                  this.state.reportPageType === "COVER_PAGE"
                                    ? this.state.mCoverSettingsLocal ||
                                      this.state.mSettingsLocal
                                    : this.state.mSettingsLocal;
                                let changedCount = 0;
                                if (original && localSettings) {
                                  Object.keys(localSettings).forEach(
                                    (key) => {
                                      if (
                                        key === "id" ||
                                        key === "eet" ||
                                        key === "eeg" ||
                                        key === "show_co_schoolistic_activity" ||
                                        key === "active_cover_page"
                                      ) {
                                        return;
                                      }
                                      const newVal = localSettings[key];
                                      const oldVal = original[key];
                                      if (
                                        typeof newVal === "object" &&
                                        newVal !== null
                                      ) {
                                        return;
                                      }
                                      if (
                                        typeof oldVal === "object" &&
                                        oldVal !== null
                                      ) {
                                        return;
                                      }
                                      const next =
                                        newVal === null || newVal === undefined
                                          ? ""
                                          : String(newVal);
                                      const prev =
                                        oldVal === null || oldVal === undefined
                                          ? ""
                                          : String(oldVal);
                                      if (next !== prev) {
                                        changedCount += 1;
                                      }
                                    }
                                  );
                                }
                                const hasChanges = changedCount > 0;
                                const saving = this.state.savingReportSettings;
                                return (
                                  <div
                                style={{
                                  marginTop: "8px",
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <button
                                  type="button"
                                  disabled={!hasChanges || saving}
                                  style={{
                                    borderRadius: "999px",
                                    padding: "4px 14px",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    background:
                                      hasChanges && !saving
                                        ? "linear-gradient(135deg,#22c55e 0%,#16a34a 100%)"
                                        : "#e5e7eb",
                                    border: hasChanges && !saving
                                      ? "1px solid #16a34a"
                                      : "1px solid #e5e7eb",
                                    color:
                                      hasChanges && !saving
                                        ? "#ffffff"
                                        : "#6b7280",
                                    cursor:
                                      hasChanges && !saving
                                        ? "pointer"
                                        : "not-allowed",
                                    opacity: saving ? 0.85 : 1,
                                  }}
                                  onClick={() =>
                                    hasChanges &&
                                    !saving &&
                                    this.handleSaveReportSettings()
                                  }
                                >
                                  {saving
                                    ? "Saving…"
                                    : `Save Settings (${changedCount})`}
                                </button>
                                  </div>
                                );
                              })()}
                            </div>
                          </div>
                        )}


                      <div
                        className="row"
                        style={{ margin: "0px 10px 0px 10px" }}
                      >
                        <h5 className="">Preview</h5>
                      </div>

                      <div
                        className="row preview-card"
                        style={{
                          margin: "0 10px",
                          position: "relative",
                          minHeight: "200px",
                        }}
                      >
                        {this.state.showPreview && this.state.FILE_URL ? (
                          <div
                            style={{
                              position: "absolute",
                              left: 0,
                              right: 0,
                              top: 0,
                              zIndex: 2,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              minHeight: "200px",
                              background: "rgba(255,255,255,0.9)",
                            }}
                            aria-busy="true"
                          >
                            <MyLoader />
                          </div>
                        ) : null}
                        {this.state.FILE_URL ? (
                          <div
                            key={`preview-${this.state.previewLoadNonce}`}
                            style={{ width: "100%" }}
                          >
                            <Iframe
                              url={this.state.FILE_URL}
                              width="100%"
                              height={this.state.iFrameHeight}
                              overflow="visible"
                              id="iFrameStudentData"
                              className=""
                              display="initial"
                              position="relative"
                              frameBorder="0"
                              onLoad={this.handlePreviewIframeLoad}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {this.state.isOpenSelectStudent === true ? (
                      <MdlSelectExamClassAndMultipleStudent
                        exam_id={this.state.EXAM_ID}
                        session_id={this.state.SESSION_ID}
                        action={this.HandleCloseSelectStudent}
                        action2={this.HandleSelectedStudent}
                      ></MdlSelectExamClassAndMultipleStudent>
                    ) : (
                      ""
                    )}
                    {this.state.isOpenSettings === true ? (
                      <MdlReportCardSettings
                        report_card_id={this.state.REPORT_CARD_ID}
                        sample_id={this.state.SELECTED_SAMPLE_ID}
                        color_option_id={this.state.COLOR_OPTION_ID}
                        file_url={this.state.FILE_URL}
                        active_cover_page={(() => {
                          const acp =
                            this.state.mSettingsLocal?.active_cover_page ??
                            this.state.mSettings?.[0]?.active_cover_page;
                          const acpOn =
                            this.state.needCoverPageBothSide ||
                            acp === 1 ||
                            acp === "1" ||
                            acp === true;
                          return acpOn ? 1 : 0;
                        })()}
                        actionClose={this.HandleCloseSettings}
                        actionDone={this.HandleReportCardSettingsDone}
                      />
                    ) : (
                      ""
                    )}
                  </div>
      </>
    );
  }
}
